import { render, staticRenderFns } from "./payResult.vue?vue&type=template&id=034d7b23&scoped=true&"
import script from "./payResult.vue?vue&type=script&lang=ts&"
export * from "./payResult.vue?vue&type=script&lang=ts&"
import style0 from "./payResult.vue?vue&type=style&index=0&id=034d7b23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034d7b23",
  null
  
)

export default component.exports